module.exports = __webpack_public_path__ + "static/all-the-guidelines-67a1aa4d65a803a567a02736336ed63b.gif";